/*
  Site-wide "Dhs" -> AED icon swap.

  Shopify's money format (a shop-level Settings > General setting, not theme
  code) renders every price as <span class="money">Dhs 1,234.00</span>. Rather
  than editing every template that calls the `money` filter (product cards,
  PDP, cart, quick-buy, predictive search, order history, ...) and re-deriving
  each one's exact markup, this scans for that one consistent `.money` output
  shape and swaps the text prefix for the icon -- so it also transparently
  covers variant-price updates and AJAX-rendered fragments (cart drawer,
  quick-buy modal) without hooking every individual re-render path.
*/
(function () {
  var PREFIX_PATTERN = /^\s*(?:AED|Dhs\.?)\s*/i;
  // money_with_currency renders a trailing ISO code too (e.g. "Dhs 1,234.00 AED").
  var SUFFIX_PATTERN = /\s+[A-Z]{3}\s*$/;

  function applyIcon(el) {
    if (!el || el.nodeType !== 1 || el.children.length > 0) return;
    var text = el.textContent;
    if (!PREFIX_PATTERN.test(text)) return;
    var stripped = text.replace(PREFIX_PATTERN, '').replace(SUFFIX_PATTERN, '');
    el.textContent = '';
    var icon = document.createElement('span');
    icon.className = 'cyan-aed-icon';
    icon.setAttribute('aria-hidden', 'true');
    el.appendChild(icon);
    el.appendChild(document.createTextNode(stripped));
  }

  function scan(root) {
    if (!root.querySelectorAll) return;
    if (root.classList && root.classList.contains('money')) applyIcon(root);
    root.querySelectorAll('.money').forEach(applyIcon);
  }

  // Runs immediately rather than waiting for DOMContentLoaded: this script tag
  // is deferred, so the DOM is already fully parsed by the time this executes,
  // and other deferred scripts later in document order (e.g. cyan-bought-together.js,
  // which reads a price element's rendered text at its own connectedCallback)
  // need the icon swap already applied by the time THEY run, not after.
  scan(document.body);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) scan(node);
      });
      if (mutation.type === 'characterData') {
        var parent = mutation.target.parentElement;
        if (parent && parent.classList.contains('money')) applyIcon(parent);
      }
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
